import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";
import { mergeLocaleCatalogSlices } from "./merge-message-tree";
import { redblueAcceptancePageMessages } from "./pages-workbench-acceptance";
import { redblueDirectorPageMessages } from "./pages-workbench-director";
import { redblueJudgePageMessages } from "./pages-workbench-judge";
import { redblueReviewPageMessages } from "./pages-workbench-review";

export const redblueWorkbenchPageMessages: Record<AppLocale, MessageTree> =
  mergeLocaleCatalogSlices([
    redblueDirectorPageMessages,
    redblueJudgePageMessages,
    redblueReviewPageMessages,
    redblueAcceptancePageMessages,
  ]);
